import IdentificationManager from '../IdentificationManager';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class IdentificationManagerFactory {
  private apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/identification`, headers);
  }

  public createIdentificationManager(authToken: string) {
    return new IdentificationManager(this.apiClientFactory.createAuthorizedClient(authToken));
  }
}
